import React, { useEffect, useRef } from 'react';
import { triggerHaptic } from '../utils/haptics';

const CategoryTabs = ({ categories, activeCategory, onSelect }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (activeCategory && containerRef.current) {
      const activeButton = containerRef.current.querySelector(`[data-id="${activeCategory}"]`);
      if (activeButton) {
        activeButton.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }, [activeCategory]);

  // CHANGED: Удалены классы sticky, top-0, z-20, bg-tg-bg, shadow-sm, py-3.
  // Теперь это просто контейнер для скролла, а фон/тень задаются в Menu.js
  return (
    <div 
      ref={containerRef}
      className="flex overflow-x-auto px-4 gap-2 scrollbar-hide pb-1 scroll-smooth w-full"
    >
      {categories.map((cat) => (
        <button
          key={cat.id}
          data-id={cat.id}
          onClick={() => {
            onSelect(cat.id);
            triggerHaptic('light');
          }}
          className={`
            whitespace-nowrap px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 flex-shrink-0
            ${activeCategory === cat.id 
              ? 'bg-tg-button text-white shadow-md transform scale-105' 
              : 'bg-tg-secondary-bg text-tg-text opacity-70 hover:opacity-100'}
          `}
        >
          {cat.name}
        </button>
      ))}
    </div>
  );
};

export default CategoryTabs;
